import * as React from "react";
import { DynamicIcon, iconNames, type IconName } from "lucide-react/dynamic";
import { Circle } from "lucide-react";

const VALID_ICON_NAMES = new Set<string>(iconNames);

/** Map Mongo / Lucide label (PascalCase or kebab-case) to a lucide-react dynamic icon key. */
export function normalizeLucideIconName(raw: string | undefined): IconName {
  const s = raw?.trim() ?? "";
  let name: string;

  if (!s) return "circle";
  if (s.includes("-")) name = s.toLowerCase();
  else {
    name = s
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
      .toLowerCase();
  }
  return (VALID_ICON_NAMES.has(name) ? name : "circle") as IconName;
}

export interface DynamicStatusIconProps {
  iconName?: string;
  backgroundColor: string;
  borderColor: string;
  size?: number;
}

export default function DynamicStatusIcon({
  iconName,
  backgroundColor,
  borderColor,
  size = 28,
}: DynamicStatusIconProps) {
  const name = normalizeLucideIconName(iconName);
  const iconInner = Math.max(12, Math.round(size * 0.5));

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor,
        border: `1px solid ${borderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxSizing: "border-box",
      }}
    >
      <DynamicIcon
        name={name}
        fallback={() => <Circle size={iconInner} strokeWidth={2} color="rgba(0,0,0,0.55)" />}
        size={iconInner}
        strokeWidth={2}
        color="rgba(0,0,0,0.55)"
      />
    </div>
  );
}
